/** Calendar helpers for YYYY-MM-DD values from the mentor GETs. Do not invent dates. */

export const EMPTY_MENTOR_COPY = 'You are not currently assigned as a mentor';

export function joinPresent(parts: Array<string | number | null | undefined>, sep = ' · '): string {
    return parts
        .map((part) => (part == null ? '' : String(part).trim()))
        .filter((part) => part !== '')
        .join(sep);
}

export function initialsFromName(name: string | null | undefined): string {
    const bits = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (bits.length === 0) return '?';
    if (bits.length === 1) return bits[0].slice(0, 2).toUpperCase();
    return `${bits[0][0] || ''}${bits[bits.length - 1][0] || ''}`.toUpperCase();
}

function parseCalendar(value: string | null | undefined): Date | null {
    if (!value) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value).trim());
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return Number.isNaN(date.getTime()) ? null : date;
}

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatMonthYy(value: string | null | undefined): string | null {
    const date = parseCalendar(value);
    if (!date) return null;
    const yy = String(date.getFullYear()).slice(-2);
    return `${SHORT_MONTHS[date.getMonth()]} '${yy}`;
}

export function formatDayMonthYear(value: string | null | undefined): string | null {
    const date = parseCalendar(value);
    if (!date) return null;
    return `${date.getDate()} ${SHORT_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function durationSubline(start: string | null | undefined, end: string | null | undefined): string | null {
    const startDate = parseCalendar(start);
    const endDate = parseCalendar(end);
    const endLabel = formatDayMonthYear(end);
    if (!startDate || !endDate || !endLabel) return endLabel ? `Ends ${endLabel}` : null;
    const ms = endDate.getTime() - startDate.getTime();
    const days = Math.max(0, Math.round(ms / 86400000));
    if (days < 32) {
        return `Ends ${endLabel} · ${days} day${days === 1 ? '' : 's'}`;
    }
    const months =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());
    const count = Math.max(1, months);
    return `Ends ${endLabel} · ${count} month${count === 1 ? '' : 's'}`;
}

export function roleCompanyLine(designation: string | null | undefined, company: string | null | undefined): string | null {
    const title = designation ? String(designation).trim() : '';
    const org = company ? String(company).trim() : '';
    if (title && org) return `${title}, ${org}`;
    return title || org || null;
}
